import { color, Common } from '@stockbit/ui';
import { useState } from 'react';
import useForm from 'hooks/useForm';
import { reportOptions } from '../../constants';
import { Modal, Option, Select, Button } from '../styled';

const { Text } = Common;

interface ModalDeleteAdminProps {
  multiple?: boolean;
  onDelete: (value: any) => void;
  onCancel: () => void;
  [key: string]: any;
}

function ModalDeleteAdmin({
  onDelete,
  onCancel,
  multiple = false,
  ...props
}: ModalDeleteAdminProps) {
  const [sendEmail, setSendEmail] = useState<boolean>(false);
  const [reason, setReason] = useForm({ initialState: reportOptions[0].label });
  const [time, setTime] = useForm({ initialState: '1d' });

  const timeRanges = [
    { label: '24 Hours Post', value: '1d' },
    { label: '3 Days Post', value: '3d' },
    { label: '7 Days post', value: '1w' },
  ];

  const handleCheck = () => {
    setSendEmail(!sendEmail);
  };

  const handleDelete = () => {
    const data: any = {
      reason,
      sendEmail,
    };

    if (multiple) {
      data.time = time;
    }

    onDelete(data);
  };

  return (
    <Modal
      {...props}
      onCancel={onCancel}
      title={(
        <Text size="16px" height="40px" family="bold">
          Delete Stream
        </Text>
      )}
      centered
      width={280}
      footer={[
        <Button key="cancel" block height="40px" onClick={onCancel}>
          <Text align="center">Cancel</Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="primary"
          height="40px"
          onClick={handleDelete}
        >
          <Text align="center" color={color.light}>
            Confirm
          </Text>
        </Button>,
      ]}
    >
      {multiple && (
        <>
          <Text size="12px">Delete Post For: </Text>
          <Select value={time} onChange={(e) => setTime(e)}>
            {timeRanges.map(({ value, label }) => (
              <Option key={value} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </>
      )}
      <Text size="12px">Delete Reason : </Text>
      <Select value={reason} onChange={(e) => setReason(e)}>
        {reportOptions.map(({ key, label }) => (
          <Option key={key} value={label}>
            {label}
          </Option>
        ))}
      </Select>
      <Text size="12px">Send Report to User ? </Text>
      <input type="checkbox" checked={sendEmail} onChange={handleCheck} />
    </Modal>
  );
}

export default ModalDeleteAdmin;
